var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DirMain"},[_c('div',{staticClass:"med_info"},[_c('p',{staticStyle:{"padding":"0 20px"}},[_vm._v("上海杨浦区中金金融纠纷调解中心共有调解员16名，其中男性调解员8名，女性调解员8名； 2024年度指定调解员61人次，其中指定男性调解员30人次，女性调解员31人次， 2024年度共调解成功商事纠纷案件61件； 2025年度共调解成功商事纠纷案件41件。")])]),_c('img',{attrs:{"src":require("../../../assets/mediators.png"),"width":"100%"}})])
}]

export { render, staticRenderFns }